import { APP_CONFIG } from '@/config';
import axios, { AxiosRequestConfig, Method } from 'axios';
import { from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { utilsService } from './utils.service';
import * as md5 from 'blueimp-md5';

interface Params {
  url: string;
  data?: any;
  contentType?: string;
  getParams?: string;
}

class httpRequestService {
  axios = axios;

  headers = {
    contentType: 'application/json',
    authorization: 'Front',
  };

  constructor() {
    this.initAxios();
  }

  private initAxios() {
    // 添加请求拦截器
    this.axios.interceptors.request.use(
      config => {
        // console.log('req', config);

        return config;
      },
      err => {
        // 对请求错误做些什么
        return Promise.reject(err);
      },
    );

    // 添加响应拦截器
    this.axios.interceptors.response.use(
      res => {
        // console.log('res', res);
        return res;
      },
      err => {
        // 对响应错误做点什么
        return Promise.reject(err);
      },
    );
  }

  private http(params: Params, method: Method) {
    const { url, data, getParams } = params;
    const ContentType = params.contentType || 'application/json';

    const timestamp = Date.now()
      .toString()
      .substr(0, 10);
    const sign = utilsService.raw({ ...params.data, timestamp, private_key: APP_CONFIG.privateKey });
    const headers = { timestamp, sign: md5(sign) };
    // console.log({ headers, sign });

    const config: AxiosRequestConfig = {
      params: getParams,
      url,
      data,
      method,
      headers,
    };

    return of(0).pipe(
      switchMap(() => from(this.axios(config))),
      map(res => res.data),
    );
  }

  // send(url: string, data: any, config?: AxiosRequestConfig) {
  //   return from(axios.post(url, data, { headers: this.headers })).pipe(map(res => res.data));
  // }

  // get(url: string, config?: AxiosRequestConfig) {
  //   return from(axios.get(url, { headers: this.headers })).pipe(map(res => res.data));
  // }

  patch(url: string, data: any, config?: AxiosRequestConfig) {
    return this.http({ url, data }, 'patch');
  }

  post(url: string, data: any, config?: AxiosRequestConfig) {
    return this.http({ url, data }, 'post');
  }

  get(url: string, getParams: any, config?: AxiosRequestConfig) {
    return this.http({ url, getParams }, 'get');
  }

  getOpenId(data: any) {
    const url = APP_CONFIG.wxApi + '/wejoy/openId';
    return from(axios.post(url, data, { headers: this.headers })).pipe(map(res => res.data));
  }

  getUserInfo(data: any) {
    const url = APP_CONFIG.wxApi + '/wejoy/userInfo';
    return from(axios.post(url, data, { headers: this.headers })).pipe(map(res => res.data));
  }
}

/** 单例对象函数 */
const service = (() => {
  // 隐藏的Class的构造函数
  // function TodayCilpService() {}

  // 未初始化的单例对象
  let service: httpRequestService;

  return {
    // 创建/获取单例对象的函数
    getInstance: () => {
      if (!service) {
        service = new httpRequestService();
      }
      return service;
    },
  };
})();
export const httpService = service.getInstance();
